import { forwardRef } from "react";
import { IconPropsType, Ref } from "./IconPropsType";

const WaitTime = forwardRef<Ref, IconPropsType>(
  ({ color = "currentColor", size, ...rest }, ref) => {
    return (
      <svg
        width={size ?? 18}
        height={size ?? 18}
        viewBox="0 0 18 18"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.43 17.0625H6.57C5.1525 17.0625 4.1175 16.47 3.72 15.45C3.3075 14.385 3.69 13.065 4.68 12.1725L8.16 9L4.68 5.8275C3.69 4.935 3.3075 3.615 3.72 2.55C4.1175 1.5225 5.1525 0.9375 6.57 0.9375H11.43C12.8475 0.9375 13.8825 1.53 14.28 2.55C14.6925 3.615 14.31 4.935 13.32 5.8275L9.84 9L13.3275 12.1725C14.31 13.065 14.7 14.385 14.2875 15.45C13.8825 16.47 12.8475 17.0625 11.43 17.0625ZM9 9.7575L5.4375 12.9975C4.8075 13.575 4.53 14.415 4.77 15.0375C4.995 15.615 5.6325 15.9375 6.57 15.9375H11.43C12.3675 15.9375 13.005 15.6225 13.23 15.0375C13.47 14.415 13.2 13.575 12.5625 12.9975L9 9.7575ZM6.57 2.0625C5.6325 2.0625 4.995 2.3775 4.77 2.9625C4.53 3.585 4.8 4.425 5.4375 5.0025L9 8.2425L12.5625 5.0025C13.1925 4.425 13.47 3.585 13.23 2.9625C13.005 2.385 12.3675 2.0625 11.43 2.0625H6.57Z"
          fill={color}
        />
      </svg>
    );
  },
);

export default WaitTime;
